import * as angular from "angular";
import { orderByDocumentPosition } from "../utils/orderByDocumentPosition";

export default angular
	.module("vesl.filters.orderByDocumentPosition", [])
	.filter("orderByDocumentPosition", () => orderByDocumentPosition)
	.name;
